import React, { useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// styles
import ModalContainer from '../styles/Modal/ModalStyles'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from "react-toastify";

// helpers functions
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions';

// Customer API
import { checkEmailExistence, sendResetPassword } from 'utlis/Apis/Customers_API';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";
import { BiX } from 'react-icons/bi';

function ResetPasswordModal(props) {
    // props
    const {
        email,
        commonToken,

        closeModal
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [emailConfirm, setEmailConfirm] = useState(false)

    // resetting email confirm
    useEffect(() => {
        setEmailConfirm(false)
    }, [])

    // initial form values
    const initialFormValues = {
        email: '',
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        email: Yup.string().email().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // btn loading
            setBtnLoading(true)
            setBtnDisabled(true)

            // sending password
            sendResetPassword(commonToken ?? "", values.email).then(res => {
                // btn loading
                setBtnLoading(false)
                setBtnDisabled(false)

                const resData = res.data

                // if error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error("Email not found", {
                        autoClose: 2500
                    });
                } else {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.success("Success", {
                        autoClose: 2500,
                        onClose: () => {
                            // btn loading
                            setBtnLoading(false)
                            setBtnDisabled(false)
                        },
                    });

                    setEmailConfirm(true)
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} sendResetPassword `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // btn loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    },
                });
            })

        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // setting default email address
    useEffect(() => {
        formik.setFieldValue('email', email)
    }, [email])

    // checkout press
    // const checkUserEmail = debounce((ev) => {
    //     const emailVal = ev.target.value
    //     if (emailVal) {
    //         const isValid = ev.target.checkValidity()

    //         if (isValid) { // if email format is valid
    //             // enabling laoding
    //             setBtnLoading(true)
    //             setBtnDisabled(true)

    //             // email checking api
    //             checkEmailExistence(emailVal).then(res => {
    //                 const resData = res.data
    //                 // if email does not exists
    //                 if (resData.success) {
    //                     // disabling laoding
    //                     setBtnLoading(false)

    //                     // dismissing all the previous toasts first
    //                     toast.dismiss();

    //                     // showing the error message
    //                     toast.info("No account found with this email address.", {
    //                         autoClose: 2000
    //                     });
    //                 }

    //                 // if email exists
    //                 if (resData.error) {
    //                     // disabling laoding
    //                     setBtnLoading(false)
    //                     setBtnDisabled(false)
    //                 }

    //             }).catch(err => {
    //                 console.log("Error in the checkEmailExistence Api ", err.message);
    //             })
    //         }
    //     } else {
    //         // disabling the button
    //         setBtnDisabled(true)
    //     }
    // }, 200)

    return (
        <ModalContainer className="create-account-form position-relative">
            {/* close icon */}
            <div
                className="modal-close-icon cursor-pointer position-absolute"
                style={{ top: -3, right: 0 }}
                onClick={closeModal}>
                <BiX fontSize={23} />
            </div>

            {/* header */}
            <div className="head-container mb-3">
                <p className="head st-fw-800 st-fs-20 mb-0">Reset Password</p>
                <p className="desc mb-0">Forgot you password? reset here.</p>
            </div>

            {
                emailConfirm ? (
                    <div className="email-success">
                        <p className="mb-0 d-flex mb-2">
                            <span className="st-fw-600 text-success">An email containing the reset password link has been sent to your provided email address.</span>
                        </p>
                        {/* <a href="/" onClick={ev => {
                            ev.preventDefault()
                            closeModal()
                        }}>Close Modal</a> */}
                    </div>
                ) : (
                    <div className="form-main">
                        <form
                            onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            {/* form item */}
                            <div className="form-item position-relative">
                                <label className="mb-1">Email <span className="st-fs-12">(required)</span></label>
                                <input
                                    type="email"
                                    id="email"
                                    {...formik.getFieldProps('email')}
                                />
                                {
                                    (formik.touched.email && formik.errors.email) ? (
                                        <div className="error-msg st-fs-11 text-danger position-absolute">
                                            {formik.errors.email}
                                        </div>
                                    ) : null
                                }
                            </div>

                            <button type="submit" className="btn mt-3" disabled={btnDisabled}>
                                {
                                    btnLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <span>Reterive Password</span>
                                    )
                                }
                            </button>

                        </form>
                    </div>
                )
            }

        </ModalContainer>
    )
}


const getDataFromStore = (state) => {
    return {
        tempOrderId: state.auth.tempOrderId,
        commonToken: state.auth.commonToken,
    };
};

export default connect(getDataFromStore, null)(ResetPasswordModal);